import { Grid, styled } from '@mui/material';

export const DashboardChartCardContainer = styled(Grid)(() => ({
  height: '400px'
}));
